import React, {useEffect, useState, useRef, useLayoutEffect} from "react";
import styled from 'styled-components';
import Select from 'react-select'
import {Available, Distance, calculateDistance, ensure_slug} from '../utils';
import useMapDataContext from "../contexts/MapDataContext";
import useUserInfoContext from "../contexts/UserInfoContext";

const Filterbar = styled.aside`
.select {
	&-label {
		color: #00202E;
		font-weight: bold;
		padding-bottom: 4px;
		display: block;
	}
	&__control {
		background-color: #86C2EB;
		border-color: #86C2EB !important;
		border-radius: 8px;
		cursor: pointer;
	}
	&__value-container {
		padding: 12px;
	}
	&__single-value {
		color: #033556;
		font-weight: bold;
		font-weight: 20px;
	}
	&__indicator-separator {
		display: none;
	}
	&__placeholder {
		color: #00202E;
		opacity: .5;
		font-weight: bold;
	}
	svg {
		fill: #033556;
	}
}
`


export const TypeFilter = ({types, currentFilter, updateMarkerVisibility}) => {
	const [typeFilterActive, setTypeFilterActive] = useState(false);
	const [activeTypes, setActiveTypes] = useState(types);
	const typeFilter = useRef();

	const updateToTypeFilter = (type, value) => {
		types[type] = !value;
		updateMarkerVisibility('types', types)
	}

	return (
		<div className="filter-on-type">
			<button aria-label={`Klikk for å ${typeFilterActive ? 'skjule' : 'vise'} filtrering på markører`} ref={typeFilter} onClick={() => setTypeFilterActive(!typeFilterActive)} className="filter-type"></button>
			<ul className={`type-list ${typeFilterActive ? 'list-visible' : ''}`}>
				{Object.keys(types).length && Object.entries(types).map((object) => {
					return(
						<li key={`type_${object[0]}`} className={`${currentFilter.types[object[0]] ? 'type-is-active' : ''}`}>
							<button aria-label={`Klikk for å ${currentFilter.types[object[0]] ? 'skjule' : 'vise'} markører for ${object[0]}`} tabIndex={typeFilterActive ? '0' : '-1'} onClick={() => updateToTypeFilter(object[0], object[1])}>
								<img src={`/wp-content/themes/innherred-renovasjon-2020/bb-modules/smart-map/assets/marker_${object[0][0]}.png`} alt={`Markør for ${object[0]}`} />
							</button>
						</li>
					)
				})}
			</ul>
		</div>
	)
}


export const MapSidebar = ({currentFilter, markers, updateActiveMarkerId, updateMarkerVisibility}) => {
	const {userLocation} = useUserInfoContext();
	const {filterOptions, setMarkers ,setActiveMarkerId, } = useMapDataContext();
	const sidebarRef = useRef();


	var hasResult = markers.some((marker) => {if (marker.municipality === ensure_slug(currentFilter.municipality) && currentFilter.types[`${marker.type}`]) return true});

	return (
	<Filterbar className="smart-map__sidebar">
				{filterOptions && (
					<>
						<span className="select-label">Velg kommune:</span>
						<label htmlFor="municipality-select" className="sr-only">
							Velg en kommune
						</label>
						<Select
							inputId="municipality-select"
							className="select"
							classNamePrefix="select"
							options={filterOptions}
							placeholder='Velg en kommune'
							defaultValue={currentFilter.municipality ? {
								label: currentFilter.municipality, 
								value: ensure_slug(currentFilter.municipality)
							} : ''}
							onChange={option => updateMarkerVisibility('municipality', option.value)}
							aria-label="Velg en kommune"
							isSearchable={true}
							isClearable={true}
							noOptionsMessage={() => "Ingen kommuner funnet"}
							loadingMessage={() => "Laster kommuner..."}
							screenReaderStatus={({ count }) => 
								`${count} resultat${count !== 1 ? 'er' : ''} tilgjengelig`
							}
						/>
					</>
				)}
				<ul id="deliveryLocations" className="smart-map__sidebar__navigation" ref={sidebarRef}>
					{markers && currentFilter && markers.map((marker) => {
						if (marker.municipality === ensure_slug(currentFilter.municipality) && currentFilter.types[`${marker.type}`]) {
							let markerClass = 'smart-map__sidebar__navigation__item';
							return (
								<li
								className={markerClass}
								data-type={marker.type}
								data-municipality={marker.municipality}
								data-id={marker.markerId}
								data-lat={marker.lat}
								data-lng={marker.lng}
								data-address={marker.address}
								data-distance={marker.distance}
								key={`sidebar_marker_${marker.markerId}`}
								onClick={() => updateActiveMarkerId(marker.markerId)}
								tabIndex="0"
								>
								<a className="station" onClick={() => updateActiveMarkerId(marker.markerId)}>
									<div className="station__wrapper">
										<div className="station__content">
											<h3 className="station__content__name">{marker.title}</h3>
											<Available source="sidebar" marker={marker} />
											{marker.address &&
												<span className="station__content__address">{marker.address}</span>
											}
											{userLocation && (<Distance distance={marker.distance} />)}
										</div>
										<div className="station__arrow">
											<svg xmlns="http://www.w3.org/2000/svg" width="12.683" height="22.184" viewBox="0 0 12.683 22.184">
												<path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M3.823,11.089,12.217,2.7A1.585,1.585,0,1,0,9.972.463l-9.51,9.5a1.582,1.582,0,0,0-.046,2.186l9.549,9.569a1.585,1.585,0,0,0,2.245-2.239Z" transform="translate(12.683 22.184) rotate(180)" fill="#002334"/>
											</svg>
										</div>
									</div>
								</a>
							</li>
						);
						}
					})}
					{!hasResult && (
						<div>
							<p className="smart-map__sidebar__navigation__no-hits">Ingen treff på dine filtre, prøv igjen senere. <button onClick={() => updateMarkerVisibility('reset', 'reset')} className="button">Tilbakestill filtre</button></p>
						</div>
					)}
				</ul>
	</Filterbar>
	)
}

// export default [MapSidebar, TypeFilter];
